module.exports = __webpack_public_path__ + "static/media/icon-volume-low.32278b7a.svg";